module.exports = __webpack_public_path__ + "static/media/metal-roof.ece95357.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/metal-roof.png
// module id = 875
// module chunks = 1